import { ShieldCheck, Wrench, Clock, BadgeCheck } from "lucide-react";

const ABOUT_IMG = "/images/about-techs.jpg";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Licensed & insured",
    body: "Fully bonded crew. Every install is backed by a workmanship guarantee — in writing.",
  },
  {
    icon: Wrench,
    title: "Specialists, not generalists",
    body: "Smart-home certified technicians. We don't sub-contract — your installer is our employee.",
  },
  {
    icon: Clock,
    title: "Same-week scheduling",
    body: "Pick a date on this page. We confirm by phone within hours, not days.",
  },
  {
    icon: BadgeCheck,
    title: "Flat-rate, no surprises",
    body: "Pricing locked in before we arrive. Add-ons quoted on the spot — never sneaky line items.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#0A0A0C] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden border border-white/10">
            <img
              src={ABOUT_IMG}
              alt="Technician installing smart home device"
              className="w-full h-[420px] md:h-[520px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C]/70 via-transparent to-transparent" />
          </div>

          <div className="absolute -bottom-6 -right-6 hidden md:block bg-[#121216] border border-[#D4AF37]/30 rounded-2xl p-6 max-w-[240px] shadow-xl">
            <div className="text-3xl font-semibold text-[#D4AF37]">4.9★</div>
            <div className="text-xs text-white/60 uppercase tracking-[0.18em] mt-1">
              Avg. across 600+ reviews
            </div>
          </div>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-[#D4AF37] font-semibold mb-3">
            About All Service Proz
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tighter text-white">
            Atlanta's go-to crew for
            <span className="block text-white/55">premium home installations.</span>
          </h2>
          <p className="mt-6 text-white/65 text-base md:text-lg leading-relaxed">
            For a decade, we've been the team Atlanta homeowners call when they want it done
            right the first time. From doorbell cameras to full home theaters — we obsess over
            the details others skip.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-5">
            {PILLARS.map((p) => (
              <div
                key={p.title}
                data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z-]/g, "")}`}
                className="p-5 rounded-xl bg-[#121216] border border-white/10 hover:border-[#D4AF37]/40 transition-colors duration-300"
              >
                <p.icon size={22} className="text-[#D4AF37]" strokeWidth={1.6} />
                <h3 className="mt-3 text-white font-semibold">{p.title}</h3>
                <p className="mt-1.5 text-sm text-white/55 leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
